import { SearchConfig } from "@/components/dynamic-form";

export function getInitialValues(configList: SearchConfig[]) {
  return configList.reduce((result, curr) => {
    result[curr.field] = curr.props?.defaultValue;
    return result;
  }, {} as any);
}
